import { CalendarFilter } from './types';

export function esensDefaultFilters(): { [key: string]: CalendarFilter } {
    return {
        Address: {
            propertyName: 'Address',
            propertyFilters: [{ operator: 'eq', value: 'Robotnicza70j' }],
        },
        GroupDanceStyle: {
            propertyName: 'GroupDanceStyle',
            propertyFilters: [],
        },
        StartDate: {
            propertyName: 'StartDate',
            propertyFilters: [{ operator: 'lt', value: new Date().toISOString() }],
        },
        InstructorName: {
            propertyName: 'InstructorName',
            propertyFilters: [],
        },
        Name: {
            propertyName: 'Name',
            propertyFilters: [],
        },
        AdvanceLevel: {
            propertyName: 'AdvanceLevel',
            propertyFilters: [],
        },
        DanceStyleCategories: {
            propertyName: 'DanceStyleCategories',
            propertyFilters: [],
        },
        GroupType: {
            propertyName: 'GroupType',
            propertyFilters: [],
        },
    };
}

export function zoukDefaultFilters(): { [key: string]: CalendarFilter } {
    return {
        Address: {
            propertyName: 'Address',
            propertyFilters: [],
        },
        GroupDanceStyle: {
            propertyName: 'GroupDanceStyle',
            propertyFilters: [
                { operator: 'eq', value: 'Brazilian Zouk' },
                { operator: 'eq', value: 'Body & Soul' },
            ],
        },
        StartDate: {
            propertyName: 'StartDate',
            propertyFilters: [],
        },
        InstructorName: {
            propertyName: 'InstructorName',
            propertyFilters: [],
        },
        Name: {
            propertyName: 'Name',
            propertyFilters: [],
        },
        AdvanceLevel: {
            propertyName: 'AdvanceLevel',
            propertyFilters: [],
        },
        DanceStyleCategories: {
            propertyName: 'DanceStyleCategories',
            propertyFilters: [],
        },
        GroupType: {
            propertyName: 'GroupType',
            propertyFilters: [],
        },
    };
}
